var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_vm.tabSelected == 1 ? [_c('SummaryFleetStatus'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("REPORT FLEET AVAILABILITY & BREAKDOWN")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-row', [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "4"
          }
        }, [_c('v-multiselect', {
          staticClass: "mr-2",
          attrs: {
            "placeholder": "Search Fleet Type",
            "label": "name",
            "options": _vm.vehicleTypes,
            "multiple": true,
            "track-by": "id"
          },
          model: {
            value: _vm.params.vehicle_type_ids,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "vehicle_type_ids", $$v);
            },
            expression: "params.vehicle_type_ids"
          }
        }, [_c('span', {
          attrs: {
            "slot": "noResult"
          },
          slot: "noResult"
        }, [_vm._v("Fleet type not found.")])])], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "4"
          }
        }, [_c('v-multiselect', {
          staticClass: "mr-2",
          attrs: {
            "placeholder": "Search Vehicle",
            "label": "name",
            "options": _vm.vehicleComputed,
            "multiple": true,
            "track-by": "id"
          },
          model: {
            value: _vm.params.vehicle_ids,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "vehicle_ids", $$v);
            },
            expression: "params.vehicle_ids"
          }
        }, [_c('span', {
          attrs: {
            "slot": "noResult"
          },
          slot: "noResult"
        }, [_vm._v("Vehicle not found.")])])], 1), _c('b-col', {
          staticClass: "mb-3 d-flex align-items-center",
          attrs: {
            "md": "3"
          }
        }, [_c('date-picker', {
          staticClass: "mb-2 mr-2",
          staticStyle: {
            "width": "220px"
          },
          attrs: {
            "type": "year"
          },
          model: {
            value: _vm.params.year,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "year", $$v);
            },
            expression: "params.year"
          }
        }), _c('b-button', {
          attrs: {
            "disabled": _vm.loadingExport,
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.handleExportTechnical
          }
        }, [_vm.loadingExport ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.loadingExport ? 'Exporting...' : 'Export') + " ")], 1)], 1), _c('b-col', {
          staticClass: "mt-3",
          attrs: {
            "md": "12"
          }
        }, [_c('PercentageAvailability', {
          attrs: {
            "params": _vm.params
          }
        }), _c('b-sidebar', {
          attrs: {
            "title": "Breakdown Record",
            "right": "",
            "width": "100%",
            "bg-variant": "white",
            "shadow": "",
            "backdrop": ""
          },
          model: {
            value: _vm.showDetail,
            callback: function callback($$v) {
              _vm.showDetail = $$v;
            },
            expression: "showDetail"
          }
        }, [_vm.showDetail ? _c('div', {
          staticClass: "px-5"
        }, [_c('PlanAndEmergencyDetail', {
          attrs: {
            "params": _vm.params
          }
        })], 1) : _vm._e()])], 1)], 1)];
      },
      proxy: true
    }], null, false, 4285554293)
  })], 1)], 1)] : [_c('SummaryTotalBudget'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('BudgetExpanse')], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('BudgetPlanVsExpanse')], 1)], 1), _c('SummaryDocking'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('BudgetDockingCategory')], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('BudgetExpanseVsPlan')], 1)], 1)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }